import { render } from "./IconEdit.vue?vue&type=template&id=d21b6fc4"
import script from "./IconEdit.vue?vue&type=script&lang=ts"
export * from "./IconEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script